import { getActivityLogsApi } from '../../api/activitylog/activitylog-api';

export const types = {
  ACTIVITY_LOG_REQUEST: 'ACTIVITY_LOG_REQUEST',
  ACTIVITY_LOG_SUCCESS: 'ACTIVITY_LOG_SUCCESS',
  ACTIVITY_LOG_FAIL: 'ACTIVITY_LOG_FAIL',
};

export const getActivityLogs = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.ACTIVITY_LOG_REQUEST });
      const { data } = await getActivityLogsApi(id);
      dispatch({
        type: types.ACTIVITY_LOG_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: types.ACTIVITY_LOG_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
};
